// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { PasswordPushFlow } from "./password_push_flow";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowRef
 */
export interface PasswordPushFlowRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest
 */
export interface PasswordPushFlowSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowRef refs = 3;
     */
    refs: PasswordPushFlowRef[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse
 */
export interface PasswordPushFlowSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlow list = 1;
     */
    list: PasswordPushFlow[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest
 */
export interface SearchAvailablePasswordPushFlowsForUserRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse
 */
export interface SearchAvailablePasswordPushFlowsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlow list = 1;
     */
    list: PasswordPushFlow[];
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowRef$Type extends MessageType<PasswordPushFlowRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowRef
 */
export const PasswordPushFlowRef = new PasswordPushFlowRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowSearchServiceSearchRequest$Type extends MessageType<PasswordPushFlowSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest
 */
export const PasswordPushFlowSearchServiceSearchRequest = new PasswordPushFlowSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowSearchServiceSearchResponse$Type extends MessageType<PasswordPushFlowSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlow },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse
 */
export const PasswordPushFlowSearchServiceSearchResponse = new PasswordPushFlowSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAvailablePasswordPushFlowsForUserRequest$Type extends MessageType<SearchAvailablePasswordPushFlowsForUserRequest> {
    constructor() {
        super("c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest
 */
export const SearchAvailablePasswordPushFlowsForUserRequest = new SearchAvailablePasswordPushFlowsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAvailablePasswordPushFlowsForUserResponse$Type extends MessageType<SearchAvailablePasswordPushFlowsForUserResponse> {
    constructor() {
        super("c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlow }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse
 */
export const SearchAvailablePasswordPushFlowsForUserResponse = new SearchAvailablePasswordPushFlowsForUserResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowSearchService
 */
export const PasswordPushFlowSearchService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowSearchServiceSearchRequest, O: PasswordPushFlowSearchServiceSearchResponse },
    { name: "SearchAvailablePasswordPushFlowsForUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchAvailablePasswordPushFlowsForUserRequest, O: SearchAvailablePasswordPushFlowsForUserResponse }
]);
